export default __webpack_public_path__ + "static/mrjane-social-58efdb5033c0ea9b2d697b1fc4d574b8.jpg";